export const CONTACT_FLAG_THRESHOLD_DAYS = 7;
